import React, { useEffect } from "react";

const GreenRibbon = () => {
useEffect(() => {
  const textPath = document.querySelector("#scrollingText");
  let offset = 0;

  const animate = () => {
    offset += 0.09; 
    if (offset >= 100) offset = 0; 
    textPath.setAttribute("startOffset", `${offset}%`);
    requestAnimationFrame(animate);
  };

  animate();
}, []);

  const repeatedText = "  •  Innovation  •  Collaboration  •  Excellence  •  Reliability  •  Scalability  •  Integrity  •  Passion  •  Expertise  •  Growth  •  Agility  •  Vision  •  Community ".repeat(5);

  return (
    <div className="absolute top-[110px] left-0 w-full z-0 overflow-hidden pointer-events-none hidden sm:block">
     <svg width="100%" height="auto" viewBox="0 0 1441 728" fill="none" xmlns="http://www.w3.org/2000/svg">
         <defs>
          <path
            id="ribbonPath"
           d="M-32.5857 559.61C-38.0805 645.463 -12.2478 752.191 139.402 678.015C328.964 585.294 154.715 455.79 484.483 396.787C920.306 318.809 858.095 323.424 1060.52 95.1809C1163.88 -21.3579 1365.23 44.4338 1464.01 39.6572"
          />
        </defs>

        {/* Green ribbon path */}
        <use href="#ribbonPath" stroke="#00E599" strokeWidth="54" fill="none" />

        {/* Scrolling text */}
        <text
        fontSize="40"
        fill="black"
        fontFamily="Arial"
        fontWeight="bold"
        dominantBaseline="middle"
        >
        <textPath
            href="#ribbonPath"
            startOffset="50%"
            id="scrollingText"
            method="align"
            spacing="auto"
            textAnchor="middle"
        >
            {repeatedText}
        </textPath>
        </text>
      </svg>
    </div>
  );
};

export default GreenRibbon;
